import { parseItemDetails } from './formatters';
import { GHOST_DATA } from './ghostData.generated';

/**
 * Ghost-скелетоны — серые силуэты моделей. Форма зависит от МОДЕЛИ (все AK
 * одинаковые, все керамбиты одинаковые), не от скина, поэтому набор конечный и
 * целиком зашит во фронт как base64 (GHOST_DATA). Показываем как заглушку, пока
 * грузится реальная картинка скина.
 *
 * base64, а НЕ /ghosts/*.png по сети: гост-заглушка обязана рисоваться мгновенно,
 * в тот же кадр — ждать её сетевую загрузку поверх ожидания скина бессмысленно.
 * Исходные png (128px, сжаты в webp) больше не лежат в public — только в
 * git-истории; GHOST_DATA — единственный источник силуэтов.
 */
const slug = (s: string): string => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

/** base64 ghost-силуэта для айтема по его market hash name. Всегда что-то
 * возвращает: неизвестная модель → generic default. Рисуется даже при битой
 * картинке и мгновенно (data-URI, без сетевого запроса). */
export const getGhostSrc = (name: string): string => {
  const { weaponName, condition } = parseItemDetails(name);
  const key = slug(weaponName);
  if (GHOST_DATA[key]) return GHOST_DATA[key];
  if (key === 'package' || key === 'collection') return GHOST_DATA['case'];
  // Агенты: "Имя | Фракция" без износа — weaponName это имя, не модель.
  if (!condition && name.includes(' | ')) return GHOST_DATA['agent'];
  return GHOST_DATA['default'];
};
